import React, { useState, useEffect } from "react";
import "./TeamMembers.css";

const TeamMembers = ({ title, description, members, randomFlag }) => {
  const [shuffledMembers, setShuffledMembers] = useState(members);

  useEffect(() => {
    if (randomFlag) {
      setShuffledMembers([...members].sort(() => Math.random() - 0.5));
    } else {
      setShuffledMembers(members);
    }
  }, [members, randomFlag]); // Re-shuffle when members or randomFlag changes

  return (
    <div className="team-members">
      <h2>{title}</h2>
      <p className="team-description">{description}</p>
      <div className="team-cards">
        {shuffledMembers.map((member, index) => (
          <TeamMemberCard key={index} member={member} />
        ))}
      </div>
    </div>
  );
};

const TeamMemberCard = ({ member }) => {
  const [showFullText, setShowFullText] = useState(false);

  const toggleText = () => setShowFullText(!showFullText);

  const maxTextLength = 100; // Maximum characters to show before "Read More"
  const introduction = member.introduction || ""; // Default to an empty string if undefined
  const isLongText = introduction.length > maxTextLength;

  return (
    <div className="team-card">
      <img src={member.photo} alt={member.name} className="team-photo" />
      <h3>{member.name}</h3>
      <p className="team-title">{member.title}</p>
      {introduction && (
        <p className="team-introduction">
          {isLongText && !showFullText ? `${introduction.substring(0, maxTextLength)}...` : introduction}
          {isLongText && (
            <button className="read-more-btn" onClick={toggleText}>
              {showFullText ? "Read Less" : "Read More"}
            </button>
          )}
        </p>
      )}
    </div>
  );
};

export default TeamMembers;
